import { render, staticRenderFns } from "./MariChatBanner.vue?vue&type=template&id=61893566&scoped=true"
import script from "./MariChatBanner.vue?vue&type=script&lang=js"
export * from "./MariChatBanner.vue?vue&type=script&lang=js"
import style0 from "./MariChatBanner.vue?vue&type=style&index=0&id=61893566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61893566",
  null
  
)

export default component.exports